import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Wealth Design" },
  { to: "/about", label: "About Us" },
  { to: "/careers", label: "Partner With Us" },
  { to: "/contact", label: "Strategy Audit" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const handleNavClick = () => {
    setOpen(false);
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  return (
    <header className="fixed top-0 w-full z-50 bg-white/95 backdrop-blur border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center group">
          <img
            src="/logo.png"
            alt="NLS Financial Group"
            className="h-24 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={handleNavClick}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors duration-200 ${
                  isActive ? "text-gold" : "text-gray-700 hover:text-gold"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" onClick={handleNavClick} className="btn-gold text-sm px-5 py-2">
            Book a Consultation
          </Link>
        </nav>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-navy focus:outline-none"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {open ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-white border-t border-gray-200 px-6 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={handleNavClick}
              className={({ isActive }) =>
                `text-sm tracking-wide ${isActive ? "text-gold" : "text-gray-700"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" onClick={handleNavClick} className="btn-gold text-sm text-center mt-2">
            Book a Consultation
          </Link>
        </div>
      )}
    </header>
  );
}
